import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IDate } from './models/Datepicker-date-models';
import { DateValidation } from './validations/validations';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class DatePickerComponent implements OnInit {

  @Output() date = new EventEmitter<IDate>();
  @Input() cardDetailPickerminDate!: Date;
  @Input() cardDetailPickermaxDate!: Date;
  @Input() width!: string;
  @Input() submitted: boolean = false;

  disableSelect = new FormControl(false);

  error: string | null = null;

  dateForm!: FormGroup;
  monthForm = new FormControl('', Validators.required);
  yearForm = new FormControl('', Validators.required);

  months:string[] = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  years:string[] = [];

  private subscriptions = new Subscription();

  constructor(private translate:TranslateService){
      this.dateForm = new FormGroup({
        month: this.monthForm,
        year: this.yearForm,
      });
  }

  ngOnInit(){
    const minYear:number = Number(this.cardDetailPickerminDate.getFullYear());
    const maxYear:number = this.cardDetailPickermaxDate.getFullYear();
    const maxMonth:number = this.cardDetailPickermaxDate.getMonth() + 1;
    const minMonth:number = this.cardDetailPickerminDate.getMonth();

    let rangeArray = this.range(minYear, maxYear);

    this.years = []

    for(let year of rangeArray){
      this.years = [String(year), ...this.years]
    }
    
    this.dateForm.valueChanges.subscribe(
      (selectedDate:IDate) => {
        if(
          this.dateForm.controls['month'].valid &&
          this.dateForm.controls['year'].valid
        ){
          if(
            DateValidation(
              Number(selectedDate.month),
              Number(selectedDate.year),
              minMonth,
              minYear,
              maxMonth,
              maxYear
          )){
            this.date.emit(selectedDate);
            this.error = null;
          }else{
            this.error = 
              minMonth 
              + "/" + 
              minYear 
              + " - " +   
              maxMonth
              + "/" + 
              maxYear
              + ", " + this.getErrorMessage('CARDOPERATIONS_DATEPICKER_INVALID_INTERVAL_ERROR');
            ;
          }
        }else{
          this.error = this.getErrorMessage('CARDOPERATIONS_DATEPICKER_MISSING_DATE_ERROR');
        }
     
      }
    )
  }

  private getErrorMessage(errorType:string): string{
    let error!:string;
    this.subscriptions.add(
      this.translate.get(errorType).subscribe(i18Name => {
        error = i18Name;
      })
    );
    return error;
  }

  private range(start:number, end:number) {
    return Array.from({length: end-start+1}, (v, i) => i+start)
  }


}
